import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Homepage from './pages/Homepage';
import Public from './pages/Public';
import Rrzj from './pages/RRZJ';
import Descriptions from './pages/Descriptions';
import Glossary from './pages/Glossary';
import FilterDescriptors from './pages/FilterDescriptors';
import Navigace from './components/Navigation/Navigace';
import MyFooter from './components/Footer';
import Download from './pages/Download';
import Articles from './pages/Articles';

import rrzj_db from "./db.json";
import popisy_db from "./popisy.json";
import articles_db from "./articles.json";
import english_db from "./english.json";
import Search from './pages/Search';
import NotFound from './pages/404';
import FilterPopisy from './pages/FilterPopisy';

function App() {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    // if not a hash link, scroll to top
    if (hash === '') {
      window.scrollTo(0, 0);
    }
    // else scroll to id
    else {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView();
        }
      }, 0);
    }
  }, [pathname, hash, key]); // do this on route change


  return (
    <div>

      <div style={{ height: '97px', borderBottom: '1px solid #C4C4C4' }}>
        <Navigace />
      </div>

      <div>
        <Routes>
          <Route path='/' element={<Homepage />} />

          <Route path='/rrzj' element={<Rrzj />} />
          <Route path='/rrzj/:slug' element={<Articles baselink="rrzj" db={rrzj_db} />} />

          <Route path='/vyhledavani/' element={<Search />} />
          <Route path='/vyhledavani/rrzj' element={<FilterDescriptors />} />
          <Route path='/vyhledavani/popisy' element={<FilterPopisy />} /> 

          <Route path='/popisy' element={<Descriptions />} />
          <Route path="/popisy/:slug" element={<Articles baselink="popisy" db={popisy_db} />} />

          <Route path='/glosar' element={<Glossary />} />
          <Route path='/proverejnost' element={<Public />} />
          <Route path='/proverejnost/:slug' element={<Articles baselink="proverejnost" db={articles_db} hideTOC />} />
          <Route path='/download' element={<Download />} />

          {/* <Route path='/about' element={<About />} /> */}
          <Route path='/enis' element={<Articles baselink="enis" db={english_db} hideButtons />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
      </div>
      <div>
        <MyFooter />
      </div>
    </div>
  );
}

export default App;
